import {Component, inject} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {Button} from "primeng/button";
import {UserService} from "../../../services/user.service";
import {ConfirmationService, MessageService} from "primeng/api";

@Component({
  standalone: true,
  imports: [
    PageTitleComponent,
    Button
  ],
  templateUrl: './account-my-data-page.component.html',
})
export class AccountMyDataPageComponent {
  private readonly userService = inject(UserService);
  private readonly confirmService = inject(ConfirmationService);
  private readonly messageService = inject(MessageService);

  onDeleteClick() {
    this.confirmService.confirm({
      header: 'Delete account',
      message: 'Are you sure really sure you want to request your account will be deleted? We will delete if after 30 days.',
      accept: () => {
        this.userService.requestDeletion().subscribe(
          () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Account deletion requested, we will delete your account after 30 days.'
            });
          }
        );
      }
    });
  }
}
